import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { Button } from '@/components/tiptap-editor/tiptap-ui-primitive/button';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';
import { ChevronDownIcon, XIcon } from 'lucide-react';

export function ZyProblemSolutionNodeView({ deleteNode, decorations, editor }: ReactNodeViewProps) {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const handleDelete = () => {
        if (window.confirm('Are you sure you want to remove this solution?')) {
            deleteNode();
        }
    };

    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div className="rounded-md border-2 border-dashed border-gray-300 px-2">
                <div className="mb-1 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="font-bold">Solution</div>
                        <ChevronDownIcon />
                    </div>
                    <Button
                        type="button"
                        onClick={handleDelete}
                        className="rounded text-gray-500 transition-all"
                        data-style="ghost"
                        aria-label="Remove solution"
                        disabled={isEditorReadonly}
                        tooltip="Remove solution"
                    >
                        <XIcon className="h-4 w-4" />
                    </Button>
                </div>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}
